import React from "react";
import { convertTimeToText } from "../constants/methods";

import useSound from "use-sound";
import increase from "../assets/sound/increase.mp3"
import decrease from "../assets/sound/decrease.mp3"

export default function Setting({ name, time, setTime }) {
    const [playDecrease] = useSound(decrease)
    const [playIncrease] = useSound(increase)

    const click = (state) => {
        if(state == "-"){
            playDecrease()
        }
        else if(state == "+"){
            playIncrease()
        }

        setTime(state)
    }

    return (
        <div className="setting">
            <h3 className="setting-label">{name}</h3>
            <div className="setting-counter">
                <input
                    onClick={() => click("-")}
                    className="setting-counter-decrease"
                    type="button"
                    value="-"
                />
                <h3 className="setting-counter-value">
                    {convertTimeToText(time)}
                </h3>
                <input
                    onClick={() => click("+")}
                    className="setting-counter-increase"
                    type="button"
                    value="+"
                />
            </div>
        </div>
    );
}
